import { Component, inject } from '@angular/core';
import { UserDetailsComponent } from '../user-details/user-details.component';
import { UserPhotosComponent } from '../user-photos/user-photos.component';
import { UserFriendsComponent } from '../user-friends/user-friends.component';
import { QuickSearchComponent } from '../quick-search/quick-search.component';
import { PostsComponent } from '../posts/posts.component';
import { OnlineMemberComponent } from '../online-member/online-member.component';
import { SuggestionUserComponent } from '../suggestion-user/suggestion-user.component';
import { SugUserComponent } from "../sug-user/sug-user.component";


@Component({
  selector: 'app-activity-tab',
  standalone: true,
  imports: [UserDetailsComponent, UserPhotosComponent, UserFriendsComponent, QuickSearchComponent, SuggestionUserComponent, PostsComponent, OnlineMemberComponent, SugUserComponent],
  templateUrl: './activity-tab.component.html',
  styleUrl: './activity-tab.component.css'
})
export class ActivityTabComponent {
  isActivity=true;
  

}
